import * as moment from 'moment';
import { Routes } from '../_controllers/RouteController';
import * as images from '../images/images';

export enum NotificationType {
    PhotoAdded,
    TextComment,
    AudioComment,
    AddedToFamily,
    StoryShared,
    FamilyNameChange,
    AcceptedInvite,
}

interface ICommentAddedEvent {
    type_id: NotificationType.TextComment | NotificationType.AudioComment | NotificationType.PhotoAdded;
    collection_id: number;
    photo_id: number;
    by_user_id: number;
    photos_added_count?: number;
}

interface IStorySharedEvent {
    type_id: NotificationType.StoryShared;
    collection_id: number;
    family_id: number;
    by_user_id: number;
}

interface IAddedToFamilyEvent {
    type_id: NotificationType.AddedToFamily | NotificationType.FamilyNameChange | NotificationType.AcceptedInvite;
    family_id: number;
    by_user_id: number;
}

type NotificationEvent = ICommentAddedEvent | IStorySharedEvent | IAddedToFamilyEvent;

export interface IServerNotification {
    _id: string;
    user_id: number;
    event: NotificationEvent;
    created_at: number;
    was_clicked: boolean;
}

export class Notification {
    public readonly id: string;
    public readonly text: string;
    public readonly createdDateTime: moment.Moment;
    public readonly icon: any;
    public readonly isRead: boolean;
    public readonly linkUrl: string;

    public constructor(data: IServerNotification, text: string) {
        this.id = data._id;
        this.text = text;
        this.createdDateTime = moment(data.created_at);
        this.icon = Notification.getIconForNotificationType(data.event.type_id);
        this.isRead = data.was_clicked;
        this.linkUrl = Notification.getLinkUrl(data);
    }

    private static getIconForNotificationType(type: NotificationType): string {
        switch (type) {
            case NotificationType.PhotoAdded:
                return images.NotificationPhotoIcon;
            case NotificationType.TextComment:
                return images.NotificationCommentIcon;
            case NotificationType.AudioComment:
                return images.NotificationRecordingIcon;
            case NotificationType.AddedToFamily:
            case NotificationType.FamilyNameChange:
            case NotificationType.AcceptedInvite:
                return images.NotificationFamilyIcon;
            case NotificationType.StoryShared:
                return images.NotificationStoryIcon;
            default:
                throw new Error(`Invalid notification type of ${type} provided`);
        }
    }

    private static getLinkUrl(data: IServerNotification): string {
        switch (data.event.type_id) {
            case NotificationType.PhotoAdded:
            case NotificationType.TextComment:
            case NotificationType.AudioComment:
                if (!data.event.collection_id || !data.event.photo_id) {
                    return '';
                }
                return Routes.PHOTO_VIEWER.replace(':id', data.event.collection_id.toString()).replace(
                    ':photoID?',
                    data.event.photo_id.toString(),
                );
            case NotificationType.AddedToFamily:
            case NotificationType.FamilyNameChange:
            case NotificationType.AcceptedInvite:
                return Routes.FAMILY_DETAIL.replace(':id', data.event.family_id.toString());
            case NotificationType.StoryShared:
                return Routes.PHOTO_VIEWER.replace(':id/:photoID', data.event.collection_id.toString());
            default:
                throw new Error(`Invalid notification type of ${data.event!.type_id} provided`);
        }
    }
}



// WEBPACK FOOTER //
// ./src/Models/Notification.ts